export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_STATUS = 'SET_STATUS'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const SET_DEVICE = 'SET_DEVICE'
export const SET_DEVICES = 'SET_DEVICES'
export const SET_DEVICEFILE = 'SET_DEVICEFILE'
export const SET_DEVICEFILES = 'SET_DEVICEFILES'
export const SET_CURRENT_DEVICE = 'SET_CURRENT_DEVICE'
export const CLEAR_DEVICES = 'CLEAR_DEVICES'
export const SET_TOOLS = 'SET_TOOLS'
export const SET_TOOL_MAKES = 'SET_TOOL_MAKES'
export const SET_FOUND_DEVICES = ' SET_FOUND_DEVICES'
export const CLEAR_FOUND_DEVICES = 'CLEAR_FOUND_DEVICES'
export const SET_ASSOCIATED_DEVICES = 'SET_ASSOCIATED_DEVICES'
export const INIT_DEVICE_DATA = 'INIT_DEVICE_DATA'
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB'
export const SET_SOURCE = 'SET_SOURCE'
export const SET_LOCATION = 'SET_LOCATION'
export const SET_SHIPMENT = 'SET_SHIPMENT'



// WEBPACK FOOTER //
// ./src/store/modules/devices/types.js